import { render, staticRenderFns } from "./AddCallCenterAdminComponent.vue?vue&type=template&id=654765d0&"
import script from "./AddCallCenterAdminComponent.vue?vue&type=script&lang=js&"
export * from "./AddCallCenterAdminComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports